<template>
  <div class="acc-photo-index">
    <Table :tableThData="tableThData" :tableTrData="tableTrData" :loading="loading" :limit="limit" :offset="offset"
      :total="total" v-on:handleSizeChange="handleSizeChange" v-on:handleCurrentChange="handleCurrentChange">
      <template #invoiceTime="{ row }">{{ row.invoiceTime ? $moment(row.invoiceTime).format('YYYY/MM/DD HH:mm:ss') :
        '---' }}</template>
      <template #invoiceState="{ row }">
        <el-tag size="small" type="success" v-if="row.invoiceState == 1">开票成功</el-tag>
        <el-tag size="small" type="danger" v-if="row.invoiceState == 2">开票失败</el-tag>
        <el-tag size="small" v-if="row.invoiceState == 3">待开票</el-tag>
      </template>
      <template #invoiceCode="{ row }">{{ row.invoiceCode }}</template>
      <template #invoiceEmail="{ row }">{{ row.invoiceEmail }}</template>
      <template #invoiceType="{ row }">
        <el-tag size="small" type="success" v-if="row.invoiceType == 1">企业</el-tag>
        <el-tag size="small" v-else>个人</el-tag>
      </template>
      <template #invoiceRise="{ row }">{{ row.invoiceRise }}</template>
      <template #operation="{ scope }">
        <auth-button auth="member:point:apply:examine">
          <el-button type="text" @click="onApply(scope.row)">详情</el-button>
        </auth-button>
      </template>
    </Table>

    <!-- 弹窗 -->
    <Dialog :maskClose="false" :dialogShow="DialogShow" title="发票详情" @maskClick="() => { DialogShow = false }">
      <template>
        <div class="apply">
          <el-form :hide-required-asterisk="true" ref="applyForm" :model="applyForm" label-width="100px">
            <el-form-item label="停车缴费id">
              {{ applyForm.billId }}
            </el-form-item>
            <el-form-item label="发票状态">
              <el-tag size="small" type="success" v-if="applyForm.invoiceState == 1">开票成功</el-tag>
              <el-tag size="small" type="danger" v-if="applyForm.invoiceState== 2">开票失败</el-tag>
              <el-tag size="small" v-if="applyForm.invoiceState == 3">待开票</el-tag>
            </el-form-item>
            <!-- <el-form-item label="发票代码"> {{ applyForm.invoiceCode }}</el-form-item> -->
            <el-form-item label="发票号码">{{ applyForm.invoiceNumber }} </el-form-item>
            <el-form-item label="开票日期">{{ applyForm.invoiceTime ? $moment(applyForm.invoiceTime).format('YYYY年MM月DD日 HH:mm:ss') : '---' }}</el-form-item>
            <el-form-item label="校验码"> {{ applyForm.invoiceCheckCode }} </el-form-item>
            <el-form-item label="发票pdf链接"> <a :href="applyForm.invoicePdfUrl" target=“_blank”>{{ applyForm.invoicePdfUrl }}</a></el-form-item>
            <el-form-item label="接收邮箱"> {{ applyForm.invoiceEmail }} </el-form-item>
            <el-form-item label="发票序列号"> {{ applyForm.invoiceSerialNos }}</el-form-item>
            <el-form-item label="抬头类型"> {{ applyForm.invoiceType == 1 ? '企业' : '个人' }}</el-form-item>
            <el-form-item label="发票抬头">{{ applyForm.invoiceRise }}</el-form-item>
            <el-form-item label="发票金额"> {{ applyForm.invoiceAmount }}元</el-form-item>
            <el-form-item label="联系电话">{{ applyForm.phone }}</el-form-item>
            <el-form-item label="公司税号">{{ applyForm.recognition }}</el-form-item>
            <el-form-item label="公司地址">{{ applyForm.companyAddress }}</el-form-item>
            <el-form-item label="开户银行">{{ applyForm.bankDeposit }}</el-form-item>
            <el-form-item label="开户账号">{{ applyForm.accountOpening }}</el-form-item>
            <el-form-item label="备注">{{ applyForm.remark }}</el-form-item>
          </el-form>

          <div class="button-div">
            <el-row class="button-div-row">
              <el-button type="default" class="cancel" @click="() => { DialogShow = false }">关闭</el-button>
            </el-row>
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>

import AuthButton from '@/components/AuthButton'
import { api_getInvoiceList } from '@/api/parking'
import tableList from '@/mixins/tableList';
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import Dialog from "@/components/Dialog/index";
export default {
  name: "invoiceControl",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
    Dialog
  },
  data() {
    return {
      tableThData: [
        { prop: "invoiceState", label: "发票状态", minWidth: "180", },
        // { prop: "invoiceCode", label: "发票代码", minWidth: "180", },
        { prop: "invoiceTime", label: "开票日期", minWidth: "180", },
        { prop: "invoiceEmail", label: "接收邮箱", minWidth: "180", },
        { prop: "invoiceType", label: "抬头类型", minWidth: "180", },
        { prop: "invoiceRise", label: "发票抬头", minWidth: "180", },
        { prop: "operation", label: "操作", minWidth: "150", },
      ],
      DialogShow: false,
      DialogLoading: false,
      applyForm: {},
      title: null,
      offset: 0,
      limit: 10,
    };
  },
  created() { },
  methods: {
    // 获取发票列表
    async getList() {
      this.loading = true
      try {
        const data = await api_getInvoiceList({
          offset: this.offset,
          limit: this.limit,
        })
        this.tableTrData = data.list
        this.total = 1
        this.loading = false
      } catch {
        this.loading = false
      }
    },
    // 点击详情按钮
    onApply(row) {
      console.log(row)
      this.DialogShow = true
      this.applyForm = row
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.apply {
  min-height: 170px;
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}

.acc-photo-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .look-phone-btn {
    font-size: 10px;
    color: #1A5CF5;
    margin-left: 5px;
  }

  .fun-btn-box {
    margin-top: 20px;
  }

  .url {
    width: 120px;
    height: 56px;
    object-fit: fill;
    object-fit: contain;
    object-fit: cover;
    object-fit: none;
    object-fit: scale-down;
  }

  .status {
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }

  .Passed {
    background: #05c8af;
  }

  .New {
    background: #1A5CF5;
  }

  .Reject {
    background: #F74A4A;
  }

  .button-div {
    overflow: hidden;
    float: right;
    margin-top: 33px;
    position: fixed;
    bottom: 30px;
    right: 60px;

    button {
      border: 0;
      width: 110px;
      height: 40px;
      border-radius: 2px;
      font-size: 16px;
    }

    .cancel {
      background: #F2F3F5;
      color: #666666;
    }
  }

  .ticketPicUrl {
    width: 150px;
    height: 150px;
    object-fit: fill;
    object-fit: contain;
    object-fit: cover;
    object-fit: none;
    object-fit: scale-down;
    cursor: pointer;
  }

  ::v-deep {
    .content {
      .title {
        margin-bottom: 20px;
      }

      .el-input {
        width: 100%;
      }
    }
  }
}
</style>
